// extracted by mini-css-extract-plugin
export default {"root":"tweet-in-reply-to_root__sgrx9"};